import { getAdminButtons, getAdminInfo } from '@/api/admin'
import { AdminButton, AdminInfo } from '@/types'
import { useEffect, useState } from 'react'

type UseAdminData = {
  infos: AdminInfo[] | null
  buttons: AdminButton[] | null
}

export const useAdminData = (
  token: string,
  leagueId?: string,
  teamId?: string,
  clubId?: string,
  gameId?: string
): UseAdminData => {
  const [infoData, setInfoData] = useState<AdminInfo[] | null>(null)
  const [buttonData, setButtonData] = useState<AdminButton[] | null>(null)

  useEffect(() => {
    let timeout: any
    if (leagueId || teamId || clubId || gameId) {
      getAdminInfo(token, leagueId, teamId, clubId, gameId).then((d) => {
        setInfoData(d.data)
      })
      getAdminButtons(token, leagueId, teamId, clubId, gameId).then((d) => {
        setButtonData(d.data)
      })
      timeout = setInterval(() => {
        getAdminInfo(token, leagueId, teamId, clubId, gameId).then((d) => {
          setInfoData(d.data)
        })
      }, 15000)
    }
    return () => clearInterval(timeout)
  }, [leagueId, teamId, clubId, gameId])

  return { infos: infoData, buttons: buttonData }
}
